// extracted by mini-css-extract-plugin
export default {"LogoView":"styles_LogoView__OfhKP","logo":"styles_logo__jaTsu"};